var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#E5E5E5",
    stroke: "#D4D4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 21C20.5525 21 21.0002 20.5523 21.0002 20C21.0002 19.4477 20.5525 19 20.0002 19C19.448 19 19.0002 19.4477 19.0002 20C19.0002 20.5523 19.448 21 20.0002 21Z",
    stroke: "#525252",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 14C20.5525 14 21.0002 13.5523 21.0002 13C21.0002 12.4477 20.5525 12 20.0002 12C19.448 12 19.0002 12.4477 19.0002 13C19.0002 13.5523 19.448 14 20.0002 14Z",
    stroke: "#525252",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 28C20.5525 28 21.0002 27.5523 21.0002 27C21.0002 26.4477 20.5525 26 20.0002 26C19.448 26 19.0002 26.4477 19.0002 27C19.0002 27.5523 19.448 28 20.0002 28Z",
    stroke: "#525252",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsCircle);
export default __webpack_public_path__ + "static/media/dotsCircle.cd49776a59b918211bffb557e48117b1.svg";
export { ForwardRef as ReactComponent };